import React from "react";
import { ReactTyped } from "react-typed";
import Navbar from "../Shared/Navbar/Navbar";
import Footer from "../Shared/Footer/Footer";
import RegistrationForm from "./form";
import Donation from "../Pages/Home/Donation";
import { Fade } from "react-awesome-reveal";

const Membership = () => {
  return (
    <>
      {/* Banner Shading Layer */}
      <div className="relative bg-memberimg sm:bg-bannerImg-sm md:bg-bannerImg-md lg:bg-bannerImg-lg bg-cover bg-center w-full h-[60vh] flex flex-col justify-between">
        {/* Anti-glare gradient overlay guaranteeing text-white legibility for your transparent Navbar links */}
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/50 to-transparent pointer-events-none z-10" />

        <div className="relative w-full z-20">
          <Navbar />
        </div>

        {/* Dynamic Typography Center Stack */}
        <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-4 max-w-4xl mx-auto">
          <span className="text-xs sm:text-sm font-bold tracking-widest uppercase text-emerald-800 bg-stone-100/90 px-4 py-1.5 rounded-full backdrop-blur-sm mb-3 shadow-sm">
            Join the Legacy
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-slate-900 tracking-tight leading-tight mb-2">
            Mohammadia Baria Jam E Masjid
          </h1>
          <div className="h-10 text-xl sm:text-2xl font-bold text-emerald-800">
            <ReactTyped
              strings={[
                "Life Membership Enrollment",
                "Sadaqah Jariyah Donations",
              ]}
              typeSpeed={70}
              backSpeed={50}
              loop
            />
          </div>
        </div>

        <div className="h-12 w-full bg-gradient-to-t from-stone-50 to-transparent" />
      </div>

      {/* Main Form Area Grid Block wrapper */}
      <div className="bg-stone-50/60 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <Fade direction="up" triggerOnce>
              <h2 className="text-3xl md:text-4xl font-black text-green-950 tracking-tight mb-3">
                Be Our Member
              </h2>
              <p className="text-stone-600 font-medium text-sm sm:text-base">
                Be a permanent part of our journey. Register today to receive
                your verified lifelong membership certificate.
              </p>
            </Fade>
          </div>

          <RegistrationForm />
        </div>
      </div>

      <Donation />
      <Footer />
    </>
  );
};

export default Membership;
